<script setup lang="ts">
import AvatarIcon from '@/uiKit/AvatarIcon.vue'
import IconButton from '@/uiKit/IconButton.vue'
import type { IconName } from '@/uiKit/IconName'
import IconSprite from '@/uiKit/IconSprite.vue'
import PopOver from '@/uiKit/PopOver.vue'
import { onClickOutside } from '@vueuse/core'
import { ref, useTemplateRef } from 'vue'

defineProps<{ name: string; url: string | undefined; icon: IconName | undefined }>()
defineEmits<{ (e: 'click'): void }>()

const popoverOpen = ref(false)

const trigger = useTemplateRef('trigger')
const popoverContent = useTemplateRef('popoverContent')
onClickOutside(popoverContent, (e) => {
  if (trigger.value?.$el.contains(e.target)) return
  popoverOpen.value = false
})
</script>

<template>
  <PopOver
    ref="popover"
    :open="popoverOpen"
    :auto-placement-options="{
      allowedPlacements: ['top-end', 'top', 'bottom-end', 'bottom'],
    }"
    :offset="{ mainAxis: 2, crossAxis: 0 }"
  >
    <template #trigger>
      <IconButton
        ref="trigger"
        variant="transparent"
        size="sm"
        aria-label="Show override information"
        @click="popoverOpen = !popoverOpen"
      >
        <IconSprite
          v-if="icon"
          :icon="icon"
          size="xs"
          shape="circle"
        />
        <AvatarIcon
          v-else
          :full-text="name"
          :url="url"
          shape="circle"
          size="xs"
        />
      </IconButton>
    </template>
    <template #content>
      <div ref="popoverContent">
        <slot />
      </div>
    </template>
  </PopOver>
</template>
